import type { Schema } from 'yup';
import type { ZodType } from 'zod';

import { yupValidationResolver } from './yupValidationResolver';
import { zodValidationResolver } from './zodValidationResolver';

export const getResolver = <FormValues>(
    validationSchema: Schema<any> | undefined,
    zodValidationSchema: ZodType<FormValues> | undefined,
) => {
    if (validationSchema && zodValidationSchema) {
        throw new Error(
            'Only one validation schema can be provided at the same time. Please prefer newValidationSchema.',
        );
    }

    if (validationSchema) {
        return yupValidationResolver(validationSchema);
    }

    if (zodValidationSchema) {
        return zodValidationResolver<FormValues>(zodValidationSchema);
    }

    return null;
};
